import React from "react";

// Development-only routes
// These routes are only available when NODE_ENV is 'development'
export const devRoutes =
  process.env.NODE_ENV === "development"
    ? [
        {
          path: "/dev/icons",
          lazy: async () => {
            const mod = await import("../pages/DevTools/IconShowcase");
            const IconShowcase = mod.IconShowcase ?? mod.default;
            return { Component: IconShowcase };
          },
        },
      ]
    : [];
